<template>
  <main class="instructions resources__page-topic">
    <div class="resources__top-wrap">
      <RichRenderer :richTextData="cPage?.fields?.paragraphRich" />
    </div>
    <div class="resources__content-list">
      <div
        v-for="(item, n) in instructions"
        :key="`${item.title}-${n}`"
        :ref="item.title"
        class="resources__content-item"
      >
        <a
          :href="item.payloadUrl"
          class="resources__content-item-title text-link"
          target="_blank"
          v-html="item.title"
        />
        <p class="text-description" v-html="item.description" />
      </div>
    </div>
  </main>
</template>
<script>
import { getCurrentInstance, onMounted, ref } from 'vue'

import { useContentfulComponent } from '@/components/common/contentful/composables/useContentfulComponent'

import { useErrorService } from '@/composables/useErrorService'
import { useNavigation } from '@/composables/useNavigation'
import { usePageMeta } from '@/composables/usePageMeta'
import { useTransformEntries } from '@/composables/useTransformEntries'

export default {
  name: 'Instructions',
  props: {
    cPage: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { fetchItems } = useContentfulComponent()
    const { setPageMeta } = usePageMeta()
    const errorService = useErrorService()
    const { transformEntries } = useTransformEntries()
    const { anchorToEntry } = useNavigation()
    const instance = getCurrentInstance()

    const instructions = ref([])
    const initData = async (entries) => {
      const transformedEntries = transformEntries(entries)
      instructions.value = transformedEntries.filter((instruction) => instruction.payloadUrl)
      anchorToEntry(instructions.value, instance?.refs)
    }

    setPageMeta(props.cPage?.fields?.pageMeta)

    onMounted(async () => {
      const query = {
        skip: 0,
        limit: 1000,
        include: 1,
        order: '-fields.date,sys.createdAt',
        content_type: 'resource',
        'fields.resourceGroup.sys.id': props.cPage.sys.id,
      }
      const entries = await fetchItems(query)
      if (!entries) {
        const error = new Error('No contentful entry on Resource request')
        errorService.decorateError('CONTENTFUL', error, { errorLevel: 'network' })
        throw error
      } else {
        initData(entries)
      }
    })

    return {
      instructions,
    }
  },
}
</script>
